module.exports = __webpack_public_path__ + "static/media/out.2a13f6d2.svg";